
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Infographic extends Vue {
  @Prop() portrait!: string;
  @Prop() landscape!: string;
  @Prop() mobilePortrait!: string;
  @Prop() mobileLandscape!: string;
  @Prop() alt!: string;
}
